/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VipRankAuditRouteImport } from './routes/vip-rank-audit'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProxyProfilesRouteImport } from './routes/proxy-profiles'
import { Route as ModulesRouteImport } from './routes/modules'
import { Route as MarketAnalysisRouteImport } from './routes/market-analysis'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MachinesIndexRouteImport } from './routes/machines/index'
import { Route as InstancesIndexRouteImport } from './routes/instances/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as AccountsIndexRouteImport } from './routes/accounts/index'
import { Route as MachinesMachineIdRouteImport } from './routes/machines/$machineId'
import { Route as InstancesInstanceIdRouteImport } from './routes/instances/$instanceId'
import { Route as GamesGameIdRouteImport } from './routes/games/$gameId'
import { Route as AccountsAccountIdRouteImport } from './routes/accounts/$accountId'
import { Route as AccountsAccountIdIndexRouteImport } from './routes/accounts/$accountId.index'
import { Route as GamesGameIdServer_groupsRouteImport } from './routes/games/$gameId.server_groups'
import { Route as AccountsAccountIdModulesModuleEditRouteImport } from './routes/accounts/$accountId.modules.$module.edit'

const VipRankAuditRoute = VipRankAuditRouteImport.update({
  id: '/vip-rank-audit',
  path: '/vip-rank-audit',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProxyProfilesRoute = ProxyProfilesRouteImport.update({
  id: '/proxy-profiles',
  path: '/proxy-profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const ModulesRoute = ModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketAnalysisRoute = MarketAnalysisRouteImport.update({
  id: '/market-analysis',
  path: '/market-analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MachinesIndexRoute = MachinesIndexRouteImport.update({
  id: '/machines/',
  path: '/machines/',
  getParentRoute: () => rootRouteImport,
} as any)
const InstancesIndexRoute = InstancesIndexRouteImport.update({
  id: '/instances/',
  path: '/instances/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const MachinesMachineIdRoute = MachinesMachineIdRouteImport.update({
  id: '/machines/$machineId',
  path: '/machines/$machineId',
  getParentRoute: () => rootRouteImport,
} as any)
const InstancesInstanceIdRoute = InstancesInstanceIdRouteImport.update({
  id: '/instances/$instanceId',
  path: '/instances/$instanceId',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameIdRoute = GamesGameIdRouteImport.update({
  id: '/games/$gameId',
  path: '/games/$gameId',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsAccountIdRoute = AccountsAccountIdRouteImport.update({
  id: '/accounts/$accountId',
  path: '/accounts/$accountId',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsAccountIdIndexRoute = AccountsAccountIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountsAccountIdRoute,
} as any)
const GamesGameIdServer_groupsRoute =
  GamesGameIdServer_groupsRouteImport.update({
    id: '/server_groups',
    path: '/server_groups',
    getParentRoute: () => GamesGameIdRoute,
  } as any)
const AccountsAccountIdModulesModuleEditRoute =
  AccountsAccountIdModulesModuleEditRouteImport.update({
    id: '/modules/$module/edit',
    path: '/modules/$module/edit',
    getParentRoute: () => AccountsAccountIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/market-analysis': typeof MarketAnalysisRoute
  '/modules': typeof ModulesRoute
  '/proxy-profiles': typeof ProxyProfilesRoute
  '/settings': typeof SettingsRoute
  '/timeline': typeof TimelineRoute
  '/vip-rank-audit': typeof VipRankAuditRoute
  '/accounts/$accountId': typeof AccountsAccountIdRouteWithChildren
  '/games/$gameId': typeof GamesGameIdRouteWithChildren
  '/instances/$instanceId': typeof InstancesInstanceIdRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/accounts/': typeof AccountsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/instances/': typeof InstancesIndexRoute
  '/machines/': typeof MachinesIndexRoute
  '/games/$gameId/server_groups': typeof GamesGameIdServer_groupsRoute
  '/accounts/$accountId/': typeof AccountsAccountIdIndexRoute
  '/accounts/$accountId/modules/$module/edit': typeof AccountsAccountIdModulesModuleEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/market-analysis': typeof MarketAnalysisRoute
  '/modules': typeof ModulesRoute
  '/proxy-profiles': typeof ProxyProfilesRoute
  '/settings': typeof SettingsRoute
  '/timeline': typeof TimelineRoute
  '/vip-rank-audit': typeof VipRankAuditRoute
  '/games/$gameId': typeof GamesGameIdRouteWithChildren
  '/instances/$instanceId': typeof InstancesInstanceIdRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/accounts': typeof AccountsIndexRoute
  '/games': typeof GamesIndexRoute
  '/instances': typeof InstancesIndexRoute
  '/machines': typeof MachinesIndexRoute
  '/games/$gameId/server_groups': typeof GamesGameIdServer_groupsRoute
  '/accounts/$accountId': typeof AccountsAccountIdIndexRoute
  '/accounts/$accountId/modules/$module/edit': typeof AccountsAccountIdModulesModuleEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/market-analysis': typeof MarketAnalysisRoute
  '/modules': typeof ModulesRoute
  '/proxy-profiles': typeof ProxyProfilesRoute
  '/settings': typeof SettingsRoute
  '/timeline': typeof TimelineRoute
  '/vip-rank-audit': typeof VipRankAuditRoute
  '/accounts/$accountId': typeof AccountsAccountIdRouteWithChildren
  '/games/$gameId': typeof GamesGameIdRouteWithChildren
  '/instances/$instanceId': typeof InstancesInstanceIdRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/accounts/': typeof AccountsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/instances/': typeof InstancesIndexRoute
  '/machines/': typeof MachinesIndexRoute
  '/games/$gameId/server_groups': typeof GamesGameIdServer_groupsRoute
  '/accounts/$accountId/': typeof AccountsAccountIdIndexRoute
  '/accounts/$accountId/modules/$module/edit': typeof AccountsAccountIdModulesModuleEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/login'
    | '/market-analysis'
    | '/modules'
    | '/proxy-profiles'
    | '/settings'
    | '/timeline'
    | '/vip-rank-audit'
    | '/accounts/$accountId'
    | '/games/$gameId'
    | '/instances/$instanceId'
    | '/machines/$machineId'
    | '/accounts/'
    | '/games/'
    | '/instances/'
    | '/machines/'
    | '/games/$gameId/server_groups'
    | '/accounts/$accountId/'
    | '/accounts/$accountId/modules/$module/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/login'
    | '/market-analysis'
    | '/modules'
    | '/proxy-profiles'
    | '/settings'
    | '/timeline'
    | '/vip-rank-audit'
    | '/games/$gameId'
    | '/instances/$instanceId'
    | '/machines/$machineId'
    | '/accounts'
    | '/games'
    | '/instances'
    | '/machines'
    | '/games/$gameId/server_groups'
    | '/accounts/$accountId'
    | '/accounts/$accountId/modules/$module/edit'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/login'
    | '/market-analysis'
    | '/modules'
    | '/proxy-profiles'
    | '/settings'
    | '/timeline'
    | '/vip-rank-audit'
    | '/accounts/$accountId'
    | '/games/$gameId'
    | '/instances/$instanceId'
    | '/machines/$machineId'
    | '/accounts/'
    | '/games/'
    | '/instances/'
    | '/machines/'
    | '/games/$gameId/server_groups'
    | '/accounts/$accountId/'
    | '/accounts/$accountId/modules/$module/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  LoginRoute: typeof LoginRoute
  MarketAnalysisRoute: typeof MarketAnalysisRoute
  ModulesRoute: typeof ModulesRoute
  ProxyProfilesRoute: typeof ProxyProfilesRoute
  SettingsRoute: typeof SettingsRoute
  TimelineRoute: typeof TimelineRoute
  VipRankAuditRoute: typeof VipRankAuditRoute
  AccountsAccountIdRoute: typeof AccountsAccountIdRouteWithChildren
  GamesGameIdRoute: typeof GamesGameIdRouteWithChildren
  InstancesInstanceIdRoute: typeof InstancesInstanceIdRoute
  MachinesMachineIdRoute: typeof MachinesMachineIdRoute
  AccountsIndexRoute: typeof AccountsIndexRoute
  GamesIndexRoute: typeof GamesIndexRoute
  InstancesIndexRoute: typeof InstancesIndexRoute
  MachinesIndexRoute: typeof MachinesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vip-rank-audit': {
      id: '/vip-rank-audit'
      path: '/vip-rank-audit'
      fullPath: '/vip-rank-audit'
      preLoaderRoute: typeof VipRankAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proxy-profiles': {
      id: '/proxy-profiles'
      path: '/proxy-profiles'
      fullPath: '/proxy-profiles'
      preLoaderRoute: typeof ProxyProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modules': {
      id: '/modules'
      path: '/modules'
      fullPath: '/modules'
      preLoaderRoute: typeof ModulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-analysis': {
      id: '/market-analysis'
      path: '/market-analysis'
      fullPath: '/market-analysis'
      preLoaderRoute: typeof MarketAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machines/': {
      id: '/machines/'
      path: '/machines'
      fullPath: '/machines/'
      preLoaderRoute: typeof MachinesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instances/': {
      id: '/instances/'
      path: '/instances'
      fullPath: '/instances/'
      preLoaderRoute: typeof InstancesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/': {
      id: '/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machines/$machineId': {
      id: '/machines/$machineId'
      path: '/machines/$machineId'
      fullPath: '/machines/$machineId'
      preLoaderRoute: typeof MachinesMachineIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instances/$instanceId': {
      id: '/instances/$instanceId'
      path: '/instances/$instanceId'
      fullPath: '/instances/$instanceId'
      preLoaderRoute: typeof InstancesInstanceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameId': {
      id: '/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof GamesGameIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$accountId': {
      id: '/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AccountsAccountIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$accountId/': {
      id: '/accounts/$accountId/'
      path: '/'
      fullPath: '/accounts/$accountId/'
      preLoaderRoute: typeof AccountsAccountIdIndexRouteImport
      parentRoute: typeof AccountsAccountIdRoute
    }
    '/games/$gameId/server_groups': {
      id: '/games/$gameId/server_groups'
      path: '/server_groups'
      fullPath: '/games/$gameId/server_groups'
      preLoaderRoute: typeof GamesGameIdServer_groupsRouteImport
      parentRoute: typeof GamesGameIdRoute
    }
    '/accounts/$accountId/modules/$module/edit': {
      id: '/accounts/$accountId/modules/$module/edit'
      path: '/modules/$module/edit'
      fullPath: '/accounts/$accountId/modules/$module/edit'
      preLoaderRoute: typeof AccountsAccountIdModulesModuleEditRouteImport
      parentRoute: typeof AccountsAccountIdRoute
    }
  }
}

interface AccountsAccountIdRouteChildren {
  AccountsAccountIdIndexRoute: typeof AccountsAccountIdIndexRoute
  AccountsAccountIdModulesModuleEditRoute: typeof AccountsAccountIdModulesModuleEditRoute
}

const AccountsAccountIdRouteChildren: AccountsAccountIdRouteChildren = {
  AccountsAccountIdIndexRoute: AccountsAccountIdIndexRoute,
  AccountsAccountIdModulesModuleEditRoute:
    AccountsAccountIdModulesModuleEditRoute,
}

const AccountsAccountIdRouteWithChildren =
  AccountsAccountIdRoute._addFileChildren(AccountsAccountIdRouteChildren)

interface GamesGameIdRouteChildren {
  GamesGameIdServer_groupsRoute: typeof GamesGameIdServer_groupsRoute
}

const GamesGameIdRouteChildren: GamesGameIdRouteChildren = {
  GamesGameIdServer_groupsRoute: GamesGameIdServer_groupsRoute,
}

const GamesGameIdRouteWithChildren = GamesGameIdRoute._addFileChildren(
  GamesGameIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  LoginRoute: LoginRoute,
  MarketAnalysisRoute: MarketAnalysisRoute,
  ModulesRoute: ModulesRoute,
  ProxyProfilesRoute: ProxyProfilesRoute,
  SettingsRoute: SettingsRoute,
  TimelineRoute: TimelineRoute,
  VipRankAuditRoute: VipRankAuditRoute,
  AccountsAccountIdRoute: AccountsAccountIdRouteWithChildren,
  GamesGameIdRoute: GamesGameIdRouteWithChildren,
  InstancesInstanceIdRoute: InstancesInstanceIdRoute,
  MachinesMachineIdRoute: MachinesMachineIdRoute,
  AccountsIndexRoute: AccountsIndexRoute,
  GamesIndexRoute: GamesIndexRoute,
  InstancesIndexRoute: InstancesIndexRoute,
  MachinesIndexRoute: MachinesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
